import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../../../../store";
import LocalPrivacySiteModal from "../../LocalPrivacySiteModal/LocalPrivacySiteModal";
import Default from "./ManagePrivacyContent/Default";
import CountrySpecific from "./ManagePrivacyContent/CountrySpecific";
import { LayoutState } from "../../../../../store/reducers/layout-reducer";
import "./ManagePrivacy.scss";
import {
  CountriesWithLocalPrivacy,
  EuropeCountriesExceptTurkey,
} from "../../../../../data/landing-page";
import { UtilsUser } from "../../../../../utils/UtilsUser";
import { useMyDataHooks } from "../../../../../hooks/mydata-hooks";
import { MyDataState } from "../../../../../store/reducers/mydata-reducer";
import { UserState } from "../../../../../store/reducers/user-reducer";
import { useIntersectionObserver } from "../../../../../hooks/intersection-hooks";

const ManagePrivacy: React.FC = () => {
  const { selectedCountry } = useSelector<ApplicationState, LayoutState>(
    (state) => state.layout
  );
  const { history, historyReqBody } = useSelector<
    ApplicationState,
    MyDataState
  >((state) => state.myData);
  const { userData, userCountryCode } = useSelector<
    ApplicationState,
    UserState
  >((state) => state.user);
  const [isCountryListModalOpen, setIsCountryListModalOpen] =
    useState<boolean>(false);
  const [hasLocalSite, setHasLocalSite] = useState<boolean>(false);
  const [isEuropeCountry, setIsEuropeCountry] = useState<boolean>(false);
  const { loadMyDataHistory } = useMyDataHooks();
  const ref = useRef<HTMLDivElement>(null);
  const visible = useIntersectionObserver(ref, {
    rootMargin: "0px",
    threshold: 0.8,
  });

  const removeSnapScroll = () => {
    if (!visible) {
      return;
    }
    const el = document.getElementById("main-body");
    el?.removeAttribute("class");
  };

  const addSnapScroll = () => {
    const el = document.getElementById("main-body");
    if (el?.scrollTop === 0) {
      el.classList.add("snap-scroll");
    }
  };

  const renderContent = () => {
    // Scenario 1
    // if (!hasSelectedCountryCookie) {
    //   return <Default setModalOpen={setIsCountryListModalOpen} />;
    // }

    // Scenario 2
    if (!hasLocalSite || isEuropeCountry) {
      return (
        <CountrySpecific
          setModalOpen={setIsCountryListModalOpen}
          hasLocalSite={hasLocalSite}
          isEuropeCountry={isEuropeCountry}
        />
      );
    }

    // Scenario 3
    if (
      (UtilsUser.isUserLoggedIn() && history.request_count === 0) ||
      !UtilsUser.isUserLoggedIn()
    ) {
      return <Default setModalOpen={setIsCountryListModalOpen} />;
    } else {
      return (
        <CountrySpecific
          setModalOpen={setIsCountryListModalOpen}
          hasLocalSite={hasLocalSite}
          isEuropeCountry={isEuropeCountry}
        />
      );
    }
  };

  useEffect(() => {
    const countryCode = selectedCountry.code
      ? selectedCountry.code
      : userCountryCode;

    const hasCountryLocalSite = CountriesWithLocalPrivacy.some(
      (country) => country.code === countryCode
    );

    const isEuropeCountryExceptTurkey = EuropeCountriesExceptTurkey.some(
      (country) => country.code === countryCode
    );

    setHasLocalSite(hasCountryLocalSite);
    setIsEuropeCountry(isEuropeCountryExceptTurkey);
  }, [selectedCountry, userCountryCode]);

  useEffect(() => {
    if (UtilsUser.isUserLoggedIn()) {
      loadMyDataHistory(historyReqBody);
    }
  }, [userData.loginId]);

  useEffect(() => {
    removeSnapScroll();
  }, [visible]);

  useEffect(() => {
    document
      .getElementById("main-body")
      ?.addEventListener("scroll", addSnapScroll);

    return () =>
      document
        .getElementById("main-body")
        ?.removeEventListener("scroll", addSnapScroll);
  }, []);

  return (
    <>
      <div className="manage-privacy" id="manage-privacy" ref={ref}>
        {renderContent()}
      </div>
      <LocalPrivacySiteModal
        show={isCountryListModalOpen}
        onClickClose={() => setIsCountryListModalOpen(false)}
      />
    </>
  );
};

export default ManagePrivacy;
